import { action, computed, observable } from 'mobx';
import { Coupon } from '@triplabo/web/services/types';

export const COUPON_ID = 'couponId';
export const INVITE_ID = 'inviteId';

export class CouponStore {
  @observable accessor couponId: string | null =
    sessionStorage.getItem(COUPON_ID);

  @observable accessor inviteId: string | null =
    sessionStorage.getItem(INVITE_ID);

  @observable accessor selectedCoupon: Coupon | null = null;

  @action
  setCouponId(couponId?: string) {
    if (couponId) {
      this.couponId = couponId;
      sessionStorage.setItem(COUPON_ID, couponId);
    } else {
      this.couponId = null;
      sessionStorage.removeItem(COUPON_ID);
    }
  }

  @action
  setCoupon(coupon: Coupon | null) {
    this.selectedCoupon = coupon;
  }

  @action
  clearCouponId() {
    this.couponId = null;
    sessionStorage.removeItem(COUPON_ID);
  }

  @computed
  get getCouponId(): string | null {
    return this.couponId || sessionStorage.getItem(COUPON_ID);
  }

  @computed
  get getSelectedCoupon(): Coupon | null {
    return this.selectedCoupon || null;
  }

  @action
  setInviteId(inviteId?: string) {
    if (inviteId) {
      this.inviteId = inviteId;
      sessionStorage.setItem(INVITE_ID, inviteId);
    } else {
      this.inviteId = null;
      sessionStorage.removeItem(INVITE_ID);
    }
  }

  @computed
  get getInviteId(): string | null {
    return this.inviteId || sessionStorage.getItem(INVITE_ID);
  }

  @action
  clearInviteId() {
    this.inviteId = null;
    sessionStorage.removeItem(INVITE_ID);
  }
}

const coupon = new CouponStore();

export default coupon;
